import React from 'react';
import { IBox, Content, Title, Button } from '../inspinia';
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

import { getToken, isAuthenticated } from '../../store/auth';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';
import { withRouter } from 'react-router';

class FileUpload extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = 
        {
            loading: false,
            form: this.formInitialState(),
            arquivoTemplate: '',
            idTemplateAnterior: '',
            idArquivoTemplate: '',
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
            endpointArquivo: '/arquivo-template',
            auth: this.props.auth,
        }

        this.onClickFile = this.onClickFile.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.onClickRemove = this.onClickRemove.bind(this);
        this.getFile = this.getFile.bind(this);
        this.getFileTemplate = this.getFileTemplate.bind(this);
    }

    componentDidUpdate() {
        if (this.props.idTemplate === '') {
            this.setState({ ...this.state, idTemplateAnterior: this.props.idTemplate });
        }
    }

    formInitialState () 
    {
        return {
            arquivo: '',
            tamanhoArquivo: 0
        }
    }

    getFileTemplate() {
        if (!this.props.idTemplate) {
            if (this.props.removeArquivo) {
                this.state.arquivoTemplate = '';
            }
            return;
        }

        let idTemplate = this.props.idTemplate;
        if ((this.state.idTemplateAnterior === '' || idTemplate != this.state.idTemplateAnterior)) {
            let self = this;
            self.setState({
                idTemplateAnterior: idTemplate
            });
            
            const url = `${c.API_CAMPAIGN_URL}${ this.state.endpointArquivo }/${idTemplate}`;
            const options = this.state.optionsGet;
            callApi(url, options, function (response) {
                self.setState({ ...self.state, arquivoTemplate: response });
                self.props.actions.campanha.salvarIdArquivoTemplate(response.id).then((resp) => {
                    self.setState({ idArquivoTemplate: resp })
                });
            });
        }
    }

    onClickFile() {
        if (this.state.form.tamanhoArquivo > 2000000) {
            throw (c.TOASTER_ERROR("Arquivo é maior que o limite permitido para upload!!!"));
        }

        if (this.state.form.arquivo !== '') {
            if (!isAuthenticated) {
                throw (c.MESSAGE_ERROR(c.AUTH_ERROR));
            }

            const _token = c.AUTH_HEADER(getToken());

            let data = new FormData();
            data.append('file', this.state.form.arquivo);

            const url = `${ c.API_CAMPAIGN_URL }${ this.state.endpointArquivo }`;
            const options = {
                method: 'POST',
                body: data,
                headers: {'Authorization': _token }
            };

            fetch(url, options).then(async(response) => {
                let json = await response.json();

                if (response.ok) {
                    this.setState({ arquivoTemplate: json });
                    this.props.actions.campanha.salvarIdArquivoTemplate(json.id).then((resp) => {
                        this.setState({ idArquivoTemplate: resp })
                    });
                } else {
                    c.TOASTER_ERROR(json.message);
                }
            }).catch((exception) => {
                console.log("fetch error" + exception);
            });
        }
    }

    onClickRemove() {
        if (this.state.form.arquivo !== '' || this.state.arquivoTemplate !== '') {
            let self = this;
            let idArquivo = self.state.arquivoTemplate.id;
            const templateId = this.props.idTemplate;
            const url = templateId
            ? `${c.API_CAMPAIGN_URL}${this.state.endpointArquivo}/${idArquivo}/${templateId}`
            : `${c.API_CAMPAIGN_URL}${this.state.endpointArquivo}/${idArquivo}`;

            const options = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' }
            }

            callApi(url, options, (response) => {
                self.setState({ 
                    arquivoTemplate: '',
                    idArquivoTemplate: '',
                    form: self.formInitialState()
                });
                this.props.actions.campanha.salvarIdArquivoTemplate('').then(() => {
                    c.TOASTER_SUCCESS(response.message);
                  });
            });
        }
    }

    onChangeFile(e) {
        this.setState({ 
            form : { 
                arquivo : e.target.files[0],
                tamanhoArquivo : e.target.files[0].size
            }
        });
    }

    getFile() {
        this.getFileTemplate();
        if (!this.state.arquivoTemplate.nome) {
            return (
                <form>
                    <div className="form-group">
                        <input type="file" name="arquivo-template" className="form-control-file" id="upload-arquivo" required value={this.state.arquivo} onChange={this.onChangeFile} />
                    </div>
                        <Button onClick={this.onClickFile}>Adicionar</Button>
                </form>
            );
        }

        return(
            <div className="tags fs-12 fw-400" style={{ lineHeight: "26px", padding: "0px" }}>
                <ul className="list-group">
                    <li className="list-group-item list-file-upload">
                        <div className="div-file-upload">
                            <strong style={{ fontSize: "14px" }}>{this.state.arquivoTemplate.nome}</strong>
                            <Button className="btn-danger" onClick={this.onClickRemove}>Excluir</Button>
                        </div>                    
                    </li>
                </ul>
            </div>
        );
    }

    render() {
        return (
            <IBox className="mb-0 text-center">
                <Title>
                    <h3 className="mb-2">Arquivo Anexo</h3>
                    <small className="form-text text-muted">Tipos de Arquivos Permitidos: PDF, JPG, PNG.</small>
                    <small className="form-text text-muted text-uppercase">Limite de tamanho: <strong>2M.</strong></small>
                </Title>

                <Content className="border-0 p-1">
                    {this.getFile()}
                </Content>
            </IBox>
        )
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, arquivoTemplate: state.idArquivoTemplate };
}

function mapDispatchToProps(dispatch) {
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FileUpload));